import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../../config';
import { BaseButton } from '../../../common/base-button';
import { LINK_TYPES } from '../../../models/BaseBanner';
import { goToPage, routeNaming } from '../../../routes';
import { ScreenStore } from '../../../stores/ScreenStore';
import styles from './Banner.css';

const IPropTypes = {
  banner: PropTypes.shape({
    backgroundColor: PropTypes.string.isRequired,
    buttonColor: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonTextColor: PropTypes.string.isRequired,
    description: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    linkType: PropTypes.oneOf(Object.values(LINK_TYPES)).isRequired,
    linkValue: PropTypes.number.isRequired,
    subtitle: PropTypes.string.isRequired,
    textColor: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

const getImageDensitySuffix = () => {
  if (constants.pixelDensity === 1) {
    return '1x';
  }
  return '2x';
};

const getImageSizeSuffix = (currentWidth) => {
  const { breakpoints } = constants;
  if (currentWidth >= breakpoints.extraLargeMinWidth) {
    return '-lg-';
  }
  return '-';
};

const getBackgroundImage = (imageUrl) => {
  const sizeSuffix = getImageSizeSuffix(ScreenStore.screenWidth);
  const densitySuffix = getImageDensitySuffix();

  return (
    {
      backgroundImage: `url(${imageUrl}${sizeSuffix}${densitySuffix}.jpg)`,
    }
  );
};

class Banner extends React.Component {
  constructor(props) {
    super(props);

    this._handleBannerClick = this._handleBannerClick.bind(this);
  }

  _handleBannerClick() {
    if (this.props.banner.linkType === LINK_TYPES.TO_CATEGORY) {
      goToPage(routeNaming.PRODUCT_INDEX, { subMenuId: this.props.banner.linkValue });
    } else if (this.props.banner.linkType === LINK_TYPES.TO_PRODUCT) {
      goToPage(routeNaming.PRODUCT_DETAIL, { id: this.props.banner.linkValue });
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <div
          className={styles.leftContainer}
          style={{ backgroundColor: this.props.banner.backgroundColor }}
        >
          <div
            style={{ color: this.props.banner.textColor }}
          >
            <h3 className={styles.title}>
              {this.props.banner.title}
            </h3>
            <h2 className={styles.subtitle}>
              {this.props.banner.subtitle}
            </h2>
            <p className={styles.description}>
              {this.props.banner.description}
            </p>
            <BaseButton
              className={styles.button}
              onClick={this._handleBannerClick}
              style={{
                color: this.props.banner.buttonTextColor,
                backgroundColor: this.props.banner.buttonColor,
              }}
            >
              {this.props.banner.buttonText}
            </BaseButton>
          </div>
        </div>
        <div
          className={styles.rightContainer}
          style={getBackgroundImage(this.props.banner.imageUrl)}
        />
      </div>
    );
  }
}

Banner.propTypes = IPropTypes;

const WrappedBanner = observer(Banner);

export { WrappedBanner as Banner };



// WEBPACK FOOTER //
// ./src/pages/home/banner/Banner.jsx